import { gql } from '@apollo/client';

import { REPORT_COMMON_FIELDS } from '../fragments/reportCommonFields';
import { STANDARD_DELIVERY_REPORT_FILTERS } from '../fragments/standardDeliveryReportFilters';

export const GET_STANDARD_DELIVERY_REPORT = gql`
  query GetStandardDeliveryReport($id: ID!) {
    getStandardDeliveryReport(id: $id) {
      ...reportCommonFields
      filters {
        ...standardDeliveryReportFilters
          campaigns {
              id
              name
          }
      }
    }
  }
  ${REPORT_COMMON_FIELDS},
  ${STANDARD_DELIVERY_REPORT_FILTERS}
`;
